import keyMirror from 'keymirror';

export const TooltipCursorActionTypes = keyMirror({
  SET_TOOLTIP_CONTENT: undefined,
  SET_TOOLTIP_ROTATION: undefined,
  SET_TOOLTIP_POSITION: undefined,
});
